import { createContentfulClient } from "./createContentfulClient"

export type postMetaType = {
  postTitle: string
  postUrl: string
}

type slugProp = string | string[] | undefined

export const getBlogsMeta = async (slug?: slugProp) => {
    const client = createContentfulClient()

  let skip = 0
  let postCollectionMeta: postMetaType[] = []
  let total: number

  do {
    const post = await client.getEntries({
      content_type: 'blogPost',
     'fields.postUrl': slug || '',
      skip,
      limit: 100, // fetch up to 100 items per request
    })

    if (post.items.length < 1) {
      return {
        notFound: true,
      }
    }

    total = post.total

    for (let i = 0; i < post.items.length; i++) {
      const postTitle = (post.items as any[])[i].fields.postTitle
      const postUrl = (post.items as any[])[i].fields.postUrl
      postCollectionMeta.push({ postTitle, postUrl })
    }

    skip += 100
  } while (skip < total)

    return postCollectionMeta
}